import LoadingSpinner from '@components/LoadingSpinner.tsx'
import useTypedTranslation from '@hooks/useTypedTranslation'

import type { TranslationKey } from '@/i18n'

interface GuardLoadingScreenProps {
  i18nKey?: TranslationKey
}

function GuardLoadingScreen({ i18nKey = 'common.loading' }: GuardLoadingScreenProps) {
  const { t } = useTypedTranslation()

  return (
    <div className={`
      flex h-dvh w-full flex-col items-center justify-center bg-linear-to-br from-blue-100 via-white to-blue-200
    `}>
      <LoadingSpinner size='xl' label={t(i18nKey)} />
    </div>
  )
}

export default GuardLoadingScreen